import { motion } from "framer-motion";
import { brand, home, aboutPage } from "../content/site";
import { PageHeader } from "../components/PageHeader";
import { Reveal, Eyebrow } from "../components/Reveal";
import { Marquee } from "../components/Marquee";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="About EL Well"
        title="A simpler approach to supplements."
        body={brand.intro}
      />

      {/* VISION & MISSION */}
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-16 lg:py-32" data-testid="about-vision-mission">
        <Reveal>
          <div className="grid items-start gap-6 border-t border-stone-900/15 py-12 lg:grid-cols-12 lg:gap-10 lg:py-16">
            <h2 className="font-serif text-3xl font-light text-stone-900 sm:text-4xl lg:col-span-4">
              {aboutPage.vision.title}
            </h2>
            <p className="max-w-2xl text-base leading-relaxed text-stone-600 lg:col-span-8">{aboutPage.vision.body}</p>
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="grid items-start gap-6 border-t border-stone-900/15 py-12 lg:grid-cols-12 lg:gap-10 lg:py-16">
            <h2 className="font-serif text-3xl font-light text-stone-900 sm:text-4xl lg:col-span-4">
              {aboutPage.mission.title}
            </h2>
            <p className="max-w-2xl text-base leading-relaxed text-stone-600 lg:col-span-8">{aboutPage.mission.body}</p>
          </div>
        </Reveal>
        <div className="border-t border-stone-900/15" />
      </section>

      {/* BRAND PROMISE */}
      <section className="border-y border-stone-900/10 bg-[#F3EFE6]" data-testid="about-promise">
        <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
          <Reveal>
            <Eyebrow>Our Brand Promise</Eyebrow>
            <p className="mt-8 max-w-4xl font-serif text-4xl font-light leading-[1.1] text-stone-900 sm:text-5xl lg:text-6xl">
              {aboutPage.promise}
            </p>
          </Reveal>
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-16 lg:py-32" data-testid="about-values">
        <Reveal>
          <Eyebrow>Our Core Values</Eyebrow>
        </Reveal>
        <div className="mt-14 grid gap-px overflow-hidden border border-stone-900/10 bg-stone-900/10 sm:grid-cols-2 lg:grid-cols-3">
          {aboutPage.values.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.06} className={`bg-[#FBF9F5] ${i === 4 ? "sm:col-span-2" : ""}`}>
              <div className="h-full p-10 lg:p-12">
                <p className="font-serif text-2xl font-light text-stone-300">0{i + 1}</p>
                <h3 className="mt-4 font-serif text-2xl font-light text-stone-900">{v.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-600">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Marquee />

      {/* WHAT WE BELIEVE */}
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-16 lg:py-32">
        <Reveal>
          <Eyebrow>What we believe</Eyebrow>
        </Reveal>
        <div className="mt-14">
          {home.chapters.map((c, i) => (
            <Reveal key={c.number} delay={i * 0.06}>
              <div className="grid items-start gap-6 border-t border-stone-900/15 py-10 lg:grid-cols-12 lg:gap-10 lg:py-14">
                <p className="font-serif text-5xl font-light leading-none text-stone-300 lg:col-span-2">{c.number}</p>
                <h2 className="font-serif text-3xl font-light text-stone-900 lg:col-span-4">{c.title}</h2>
                <p className="max-w-xl text-base leading-relaxed text-stone-600 lg:col-span-6">{c.body}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-stone-900/15" />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-8 lg:px-16">
        <Reveal>
          <div className="overflow-hidden border border-stone-900/10">
            <motion.img
              initial={{ scale: 1.08 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              src="/assets/bottle-wide.png"
              alt="EL Well Magnesium Glycinate — premium black bottle"
              className="max-h-[560px] w-full object-cover"
              loading="lazy"
            />
          </div>
        </Reveal>
      </section>

      <section className="border-y border-stone-900/10 bg-[#F3EFE6]">
        <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-36">
          <Reveal>
            <Eyebrow>{brand.domain}</Eyebrow>
          </Reveal>
          <h2 className="mt-8 font-serif text-5xl font-light leading-[1.05] text-stone-900 sm:text-6xl lg:text-7xl">
            <Reveal delay={0.1}>Considered supplements,</Reveal>
            <Reveal delay={0.22}>
              <span className="italic text-emerald-900">from the UK.</span>
            </Reveal>
          </h2>
        </div>
      </section>
    </div>
  );
}
